
<mat-card class="tagLineBox">
    <h2>Get in <b>Touch</b></h2>
</mat-card>
